import alertActions from 'areas/alert/actions';
import isDefined from '../is/isDefined';

export default function asyncBuilder(actionPrefix, requestFunc, requestBuilder, successHandler) {

    return function (/* args */) {

        const args = Array.from(arguments);

        function requested() {
            const request = { type: `${actionPrefix}_REQUESTED` };

            if (isDefined(requestBuilder)) {
                let mixin = requestBuilder(...args);
                return {
                    ...request,
                    ...mixin
                };
            }

            return request;
        }

        function failure(error) {
            return { type: `${actionPrefix}_FAILURE`, error };
        }

        function success(response) {
            return { type: `${actionPrefix}_SUCCESS`, ...response };
        }

        return async dispatch => {
            dispatch(requested());

            try {
                const response = await requestFunc(...args);

                if (response && response.hasOwnProperty('success') && response.success === false) {
                    dispatch(alertActions.error(response.failureReason || 'Request failed'));
                    dispatch(failure(response.failureReason || 'Request failed'));
                } else {
                    if (successHandler) {
                        successHandler(dispatch, response);
                    }

                    dispatch(success(response));
                }
            }
            catch (error) {
                dispatch(alertActions.error(error.failureReason || error.toString()));
                dispatch(failure(error.failureReason || error.toString()));
            }
        };
    }
}